import { getScanDateTimes, nutritionScanService } from '../../index';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { FormManualScanData } from '../../interfaces/customerInbodyData';

export const processCreateInbodyScan = async (
  customerId: number,
  inbodyType: InbodyType,
  manualScanData?: FormManualScanData,
) => {
  if (!manualScanData || !inbodyType) {
    await nutritionScanService.updateScansFromInbody(customerId);
    return;
  }

  const { scanDate, scanTime, ...scanInfo } = manualScanData;

  const datetimes = getScanDateTimes(scanDate, scanTime);

  await nutritionScanService.createScanManually(customerId, {
    ...scanInfo,
    datetimes,
    scanType: inbodyType,
  });
};
